function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
const TermsAndPoliciesCheckbox = /*#__PURE__*/React.forwardRef(({
  inputClassName,
  ...props
}, ref) => {
  const {
    t
  } = useTranslation();
  const link = classNames('underline', 'text-kira-blue-300');
  const termsAndPoliciesCheckbox = classNames(`${inputClassName ?? ''}`, 'text-kira-blue-500', 'rounded', 'border-slate-500', 'focus:ring-kira-blue-500');
  return /*#__PURE__*/React.createElement("label", {
    className: "flex items-center justify-center",
    htmlFor: "terms-policies"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center h-5"
  }, /*#__PURE__*/React.createElement("input", _extends({
    id: "terms-policies",
    "aria-describedby": "terms-policies-description",
    type: "checkbox",
    ref: ref
  }, props, {
    className: termsAndPoliciesCheckbox
  }))), /*#__PURE__*/React.createElement("div", {
    className: "ml-3 text-sm font-light text-slate-600"
  }, /*#__PURE__*/React.createElement("span", {
    className: "mr-0.5"
  }, t("I agree to Kira Talent's")), /*#__PURE__*/React.createElement("span", {
    id: "terms-policies-description"
  }, /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, `I agree to Kira Talent's Terms of Service and Privacy Policy`, t("I agree to Kira Talent's Terms of Service & Privacy Policy")), /*#__PURE__*/React.createElement("a", {
    className: link,
    href: "https://www.kiratalent.com/terms-checkpoint-quantitative-assessment/",
    target: "_blank",
    rel: "noopener noreferrer"
  }, t('Terms of Service')), /*#__PURE__*/React.createElement("span", null, " & "), /*#__PURE__*/React.createElement("a", {
    className: link,
    href: "https://www.kiratalent.com/privacy-policy-2/",
    target: "_blank",
    rel: "noopener noreferrer"
  }, t('Privacy Policy')))));
});
export default TermsAndPoliciesCheckbox;